import * as C from "../constants/serviceConstants";

export const serviceListReducer = (state = { services: [] }, action) => {
  switch (action.type) {
    case C.SERVICE_LIST_REQUEST:
      return { ...state, loading: true };

    case C.SERVICE_LIST_SUCCESS:
      return { loading: false, services: action.payload || [] };

    case C.SERVICE_LIST_FAIL:
      return { loading: false, error: action.payload, services: [] };

    default:
      return state;
  }
};

export const serviceBookingCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case C.SERVICE_BOOKING_CREATE_REQUEST:
      return { loading: true };

    case C.SERVICE_BOOKING_CREATE_SUCCESS:
      return { loading: false, success: true, booking: action.payload };

    case C.SERVICE_BOOKING_CREATE_FAIL:
      return { loading: false, error: action.payload };

    case C.SERVICE_BOOKING_CREATE_RESET:
      return {};

    default:
      return state;
  }
};

export const serviceOrderQuoteReducer = (state = {}, action) => {
  switch (action.type) {
    case C.SERVICE_ORDER_QUOTE_REQUEST:
      return { ...state, loading: true, error: null };

    case C.SERVICE_ORDER_QUOTE_SUCCESS:
      return {
        loading: false,
        success: true,
        quote: action.payload?.quote || null,
        service: action.payload?.service || null,
      };

    case C.SERVICE_ORDER_QUOTE_FAIL:
      return { loading: false, error: action.payload };

    case C.SERVICE_ORDER_QUOTE_RESET:
      return {};

    default:
      return state;
  }
};

export const serviceOrderCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case C.SERVICE_ORDER_CREATE_REQUEST:
      return { loading: true };

    case C.SERVICE_ORDER_CREATE_SUCCESS:
      return {
        loading: false,
        success: true,
        serviceOrder: action.payload?.serviceOrder || null,
        checkoutUrl: action.payload?.checkoutUrl || "",
        payment: action.payload?.payment || null,
      };

    case C.SERVICE_ORDER_CREATE_FAIL:
      return { loading: false, error: action.payload };

    case C.SERVICE_ORDER_CREATE_RESET:
      return {};

    default:
      return state;
  }
};

export const serviceOrderDetailsReducer = (
  state = { serviceOrder: null },
  action,
) => {
  switch (action.type) {
    case C.SERVICE_ORDER_DETAILS_REQUEST:
      return { ...state, loading: true, error: null };

    case C.SERVICE_ORDER_DETAILS_SUCCESS:
      return {
        loading: false,
        success: true,
        serviceOrder: action.payload?.serviceOrder || null,
      };

    case C.SERVICE_ORDER_DETAILS_FAIL:
      return { loading: false, error: action.payload, serviceOrder: null };

    case C.SERVICE_ORDER_DETAILS_RESET:
      return { serviceOrder: null };

    default:
      return state;
  }
};

export const serviceOrderPaymentReducer = (state = {}, action) => {
  switch (action.type) {
    case C.SERVICE_ORDER_PAYMENT_REQUEST:
      return { ...state, loading: true, error: null };

    case C.SERVICE_ORDER_PAYMENT_SUCCESS:
      return {
        loading: false,
        success: true,
        pending: Boolean(action.payload?.pending),
        serviceOrder: action.payload?.serviceOrder || null,
        checkoutUrl: action.payload?.checkoutUrl || "",
        payment: action.payload?.payment || action.payload?.serviceOrder?.payment || null,
      };

    case C.SERVICE_ORDER_PAYMENT_FAIL:
      return { loading: false, error: action.payload };

    case C.SERVICE_ORDER_PAYMENT_RESET:
      return {};

    default:
      return state;
  }
};

export const serviceOrderMessageReducer = (state = {}, action) => {
  switch (action.type) {
    case C.SERVICE_ORDER_MESSAGE_REQUEST:
      return { loading: true };

    case C.SERVICE_ORDER_MESSAGE_SUCCESS:
      return {
        loading: false,
        success: true,
        serviceOrder: action.payload?.serviceOrder || null,
      };

    case C.SERVICE_ORDER_MESSAGE_FAIL:
      return { loading: false, error: action.payload };

    case C.SERVICE_ORDER_MESSAGE_RESET:
      return {};

    default:
      return state;
  }
};

export const serviceOrderAdjustmentResponseReducer = (state = {}, action) => {
  switch (action.type) {
    case C.SERVICE_ORDER_ADJUSTMENT_RESPONSE_REQUEST:
      return { loading: true };

    case C.SERVICE_ORDER_ADJUSTMENT_RESPONSE_SUCCESS:
      return {
        loading: false,
        success: true,
        serviceOrder: action.payload?.serviceOrder || null,
      };

    case C.SERVICE_ORDER_ADJUSTMENT_RESPONSE_FAIL:
      return { loading: false, error: action.payload };

    case C.SERVICE_ORDER_ADJUSTMENT_RESPONSE_RESET:
      return {};

    default:
      return state;
  }
};

export const adminServiceListReducer = (
  state = { services: [] },
  action,
) => {
  switch (action.type) {
    case C.ADMIN_SERVICE_LIST_REQUEST:
      return { ...state, loading: true };

    case C.ADMIN_SERVICE_LIST_SUCCESS:
      return { loading: false, services: action.payload || [] };

    case C.ADMIN_SERVICE_LIST_FAIL:
      return { loading: false, error: action.payload, services: [] };

    default:
      return state;
  }
};

export const adminServiceDetailsReducer = (
  state = { service: null },
  action,
) => {
  switch (action.type) {
    case C.ADMIN_SERVICE_DETAILS_REQUEST:
      return { ...state, loading: true };

    case C.ADMIN_SERVICE_DETAILS_SUCCESS:
      return { loading: false, service: action.payload };

    case C.ADMIN_SERVICE_DETAILS_FAIL:
      return { loading: false, error: action.payload, service: null };

    default:
      return state;
  }
};

export const adminServiceCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case C.ADMIN_SERVICE_CREATE_REQUEST:
      return { loading: true };

    case C.ADMIN_SERVICE_CREATE_SUCCESS:
      return { loading: false, success: true, service: action.payload };

    case C.ADMIN_SERVICE_CREATE_FAIL:
      return { loading: false, error: action.payload };

    case C.ADMIN_SERVICE_CREATE_RESET:
      return {};

    default:
      return state;
  }
};

export const adminServiceUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case C.ADMIN_SERVICE_UPDATE_REQUEST:
      return { loading: true };

    case C.ADMIN_SERVICE_UPDATE_SUCCESS:
      return { loading: false, success: true, service: action.payload };

    case C.ADMIN_SERVICE_UPDATE_FAIL:
      return { loading: false, error: action.payload };

    case C.ADMIN_SERVICE_UPDATE_RESET:
      return {};

    default:
      return state;
  }
};

export const adminServiceDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case C.ADMIN_SERVICE_DELETE_REQUEST:
      return { loading: true };

    case C.ADMIN_SERVICE_DELETE_SUCCESS:
      return { loading: false, success: true };

    case C.ADMIN_SERVICE_DELETE_FAIL:
      return { loading: false, error: action.payload };

    case C.ADMIN_SERVICE_DELETE_RESET:
      return {};

    default:
      return state;
  }
};

export const adminServiceBookingListReducer = (
  state = { bookings: [] },
  action,
) => {
  switch (action.type) {
    case C.ADMIN_SERVICE_BOOKING_LIST_REQUEST:
      return { ...state, loading: true };

    case C.ADMIN_SERVICE_BOOKING_LIST_SUCCESS:
      return { loading: false, bookings: action.payload || [] };

    case C.ADMIN_SERVICE_BOOKING_LIST_FAIL:
      return { loading: false, error: action.payload, bookings: [] };

    default:
      return state;
  }
};

export const adminServiceBookingUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case C.ADMIN_SERVICE_BOOKING_UPDATE_REQUEST:
      return { loading: true };

    case C.ADMIN_SERVICE_BOOKING_UPDATE_SUCCESS:
      return { loading: false, success: true, booking: action.payload };

    case C.ADMIN_SERVICE_BOOKING_UPDATE_FAIL:
      return { loading: false, error: action.payload };

    case C.ADMIN_SERVICE_BOOKING_UPDATE_RESET:
      return {};

    default:
      return state;
  }
};

export const adminServiceBookingDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case C.ADMIN_SERVICE_BOOKING_DELETE_REQUEST:
      return { loading: true };

    case C.ADMIN_SERVICE_BOOKING_DELETE_SUCCESS:
      return { loading: false, success: true };

    case C.ADMIN_SERVICE_BOOKING_DELETE_FAIL:
      return { loading: false, error: action.payload };

    case C.ADMIN_SERVICE_BOOKING_DELETE_RESET:
      return {};

    default:
      return state;
  }
};

export const adminServiceOrderListReducer = (
  state = { serviceOrders: [] },
  action,
) => {
  switch (action.type) {
    case C.ADMIN_SERVICE_ORDER_LIST_REQUEST:
      return { ...state, loading: true };

    case C.ADMIN_SERVICE_ORDER_LIST_SUCCESS:
      return {
        loading: false,
        serviceOrders: action.payload?.serviceOrders || [],
      };

    case C.ADMIN_SERVICE_ORDER_LIST_FAIL:
      return { loading: false, error: action.payload, serviceOrders: [] };

    default:
      return state;
  }
};

export const adminServiceOrderDetailsReducer = (
  state = { serviceOrder: null },
  action,
) => {
  switch (action.type) {
    case C.ADMIN_SERVICE_ORDER_DETAILS_REQUEST:
      return { ...state, loading: true };

    case C.ADMIN_SERVICE_ORDER_DETAILS_SUCCESS:
      return {
        loading: false,
        serviceOrder: action.payload?.serviceOrder || null,
      };

    case C.ADMIN_SERVICE_ORDER_DETAILS_FAIL:
      return { loading: false, error: action.payload, serviceOrder: null };

    case C.ADMIN_SERVICE_ORDER_DETAILS_RESET:
      return { serviceOrder: null };

    default:
      return state;
  }
};

export const adminServiceOrderUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case C.ADMIN_SERVICE_ORDER_UPDATE_REQUEST:
      return { loading: true };

    case C.ADMIN_SERVICE_ORDER_UPDATE_SUCCESS:
      return {
        loading: false,
        success: true,
        serviceOrder: action.payload?.serviceOrder || null,
      };

    case C.ADMIN_SERVICE_ORDER_UPDATE_FAIL:
      return { loading: false, error: action.payload };

    case C.ADMIN_SERVICE_ORDER_UPDATE_RESET:
      return {};

    default:
      return state;
  }
};

export const adminServiceOrderMessageReducer = (state = {}, action) => {
  switch (action.type) {
    case C.ADMIN_SERVICE_ORDER_MESSAGE_REQUEST:
      return { loading: true };

    case C.ADMIN_SERVICE_ORDER_MESSAGE_SUCCESS:
      return {
        loading: false,
        success: true,
        serviceOrder: action.payload?.serviceOrder || null,
      };

    case C.ADMIN_SERVICE_ORDER_MESSAGE_FAIL:
      return { loading: false, error: action.payload };

    case C.ADMIN_SERVICE_ORDER_MESSAGE_RESET:
      return {};

    default:
      return state;
  }
};

export const adminServiceOrderAdjustmentReducer = (state = {}, action) => {
  switch (action.type) {
    case C.ADMIN_SERVICE_ORDER_ADJUSTMENT_REQUEST:
      return { loading: true };

    case C.ADMIN_SERVICE_ORDER_ADJUSTMENT_SUCCESS:
      return {
        loading: false,
        success: true,
        serviceOrder: action.payload?.serviceOrder || null,
      };

    case C.ADMIN_SERVICE_ORDER_ADJUSTMENT_FAIL:
      return { loading: false, error: action.payload };

    case C.ADMIN_SERVICE_ORDER_ADJUSTMENT_RESET:
      return {};

    default:
      return state;
  }
};
